//
//
//
//

/**
 * A component that is useful for filling empty space in-between flex children
 */
var script = {
  name: 'FlexSpacer'
};
export { script as default };